import { render, staticRenderFns } from "./Additional-Documents.vue?vue&type=template&id=41d545fa&"
import script from "./Additional-Documents.vue?vue&type=script&lang=js&"
export * from "./Additional-Documents.vue?vue&type=script&lang=js&"
import style0 from "./Additional-Documents.vue?vue&type=style&index=0&id=41d545fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports